// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".column-width[data-v-454fc736] {\n  width: 160px;\n}\n.account-width[data-v-454fc736] {\n  width: 240px;\n}", ""]);
// Exports
module.exports = exports;
